import { Component } from "../Component";
import { Line2 } from "../Math/Line2";
import { Vector2 } from "../Math/Vector2";

export class Line extends Component {
    mouseLocation: Vector2 | undefined;

    private _line: Line2;

    constructor(public start: Vector2, public end: Vector2) {
        super();
        this._line = new Line2(start, end);
    }

    draw(ctx: CanvasRenderingContext2D): void {
        super.draw(ctx);

        ctx?.beginPath();
        ctx?.moveTo(this.start.x, this.start.y);
        ctx?.lineTo(this.end.x, this.end.y);
        ctx?.stroke();
    }

    angle(other: Line): number {
        this._line.start = this.start;
        this._line.end = this.end;
        return this._line.angle(new Line2(other.start, other.end));
    }

    intersection(other: Line): Vector2 | undefined {
        this._line.start = this.start;
        this._line.end = this.end;
        return this._line.intersection(new Line2(other.start, other.end));
    }

    length(): number {
        this._line.start = this.start;
        this._line.end = this.end;
        return this._line.length();
    }
}